var path = 'app/scripts/modules/core/src/task/taskProgressBar.directive.html';
var html = "<div class=\"progress\" uib-tooltip-html=\"tooltip\" tooltip-append-to-body=\"true\">\n  <div class=\"progress-bar\"\n       ng-style=\"progressStyle\"\n       ng-class=\"{'progress-bar-info': task.isRunning || task.hasNotStarted,\n       'progress-bar-success': task.isCompleted,\n       'progress-bar-disabled': task.isCanceled,\n       'progress-bar-danger': task.isFailed}\"\n    >\n\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/task/taskProgressBar.directive.html
// module id = 1129
// module chunks = 0